module.exports = "<mat-spinner mode=\"indeterminate\" *ngIf=\"show\"></mat-spinner>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/common/loader/loader.component.html
// module id = ../../../../../src/app/common/loader/loader.component.html
// module chunks = main